import React from 'react'
import { Input as BaseInput, ElLabel } from './Input.styles'

/**
 * The Custom Input's component.
 */
const Input = props => {
  const {
    defaultValue,
    disabled,
    inputMode,
    label,
    max,
    min,
    name,
    onChange,
    placeholder,
    step,
    type,
    value
  } = props

  return (
    <>
      {label && <ElLabel>{label}</ElLabel>}
      <BaseInput
        defaultValue={defaultValue}
        disabled={disabled}
        inputMode={inputMode}
        max={max}
        min={min}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        step={step}
        type={type}
        value={value}
      />
    </>
  )
}

export default Input
